import { useContext } from 'react';
import useHeaderAccountModal from '@/SearchResults/useHeaderAccountModal';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useIsMobile } from '~/contexts/DeviceContext';
import ModalContext from '~/contexts/ModalContext';
import UserContext from '~/contexts/UserContext';
import {
  CustomFlexContainer,
  CustomIcon,
  CustomPrimaryButton,
  CustomTileTitle,
  FlexPanel,
  TextAndIconPanel,
  FullWidthFlexPanel
} from './SaveSearchTile.styles';
import { TileSubtitle } from '../NarrowSaveTile.styles';

const SaveSearchTile = () => {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const isMobile = useIsMobile();

  const openModal = () => {
    setCreateSavedSearchOpen(true, appliedFilters);
  };

  const successHandler = async () => {
    triggerFetchUserProfile();
    setCreateSavedSearchOpen(true, appliedFilters);
  };

  const handleOpenModal = useHeaderAccountModal({
    openModal,
    successHandler
  });

  const tileText = isMobile ? 'Save your search' : 'Save your \n search';
  const subtitleText = isMobile
    ? 'Matching vehicles straight to your inbox. Over 1,000 added every day!'
    : 'Matching vehicles straight to your inbox.\n Over 1,000 added every day!';

  return (
    <CustomFlexContainer data-qa="save-search-tile">
      <FlexPanel>
        <TextAndIconPanel>
          <CustomIcon />
          <div>
            <CustomTileTitle>{tileText}</CustomTileTitle>
            <TileSubtitle>{subtitleText}</TileSubtitle>
          </div>
        </TextAndIconPanel>
        <FullWidthFlexPanel>
          <CustomPrimaryButton
            data-analytics-id="Save Search Tile - Create Saved Search"
            isSelected
            onClick={handleOpenModal}
          >
            Save this search
          </CustomPrimaryButton>
        </FullWidthFlexPanel>
      </FlexPanel>
    </CustomFlexContainer>
  );
};

export default SaveSearchTile;
